/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Register_Onboarding_Ki_Feedback_ErrorInputs */

const en_register_onboarding_ki_feedback_error = /** @type {(inputs: Register_Onboarding_Ki_Feedback_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please select an option.`)
};

const de_register_onboarding_ki_feedback_error = /** @type {(inputs: Register_Onboarding_Ki_Feedback_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte wähle eine Option aus.`)
};

/**
* | output |
* | --- |
* | "Please select an option." |
*
* @param {Register_Onboarding_Ki_Feedback_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const register_onboarding_ki_feedback_error = /** @type {((inputs?: Register_Onboarding_Ki_Feedback_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Register_Onboarding_Ki_Feedback_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_register_onboarding_ki_feedback_error(inputs)
	return en_register_onboarding_ki_feedback_error(inputs)
});